export default {
  id: 3,
  title: 'Target #3 - Push Button',
  url: 'https://cssbattle.dev/play/3',
  colors: ['#6592CF', '#243D83', '#EEB850'],
  solution:
    '<p a><p b><p c><style>body{background:#6592CF}p{margin:0;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}p[a]{width:300;height:150;background:#243D83}p[b]{width:150;height:150;border-radius:50%;background:#243D83;border:50px solid #6592CF}p[c]{width:50;height:50;border-radius:50%;background:#EEB850}</style>',
}
